<template>
  <div class="relacionados-container relacionados">
		<div class="row justify-content-center m-0 list-credits">
			<div class="col-md-7 col-12 col-lg-4">
				<div class="">

					<h2 class="text-center creditos-title mb-5">
						{{ $t('title_relacionados') }}
					</h2>

				</div>
			</div>
		</div>
		
    <div class="row justify-content-center m-0">
			<div class="col-md-4 col-12 col-lg-4 mb-4" v-for="(n, ix) in $t('relacionadas')" :key="ix">
				<div class="item-relacionados row  p-md-3">
          <div class="col-5 col-md-12 p-0">
            <a :href="n.link" target="_blank"><img :src="n.image"  width="100%" /></a>
          </div>
          <div class="col-7 col-md-12  pr-0  align-self-center">
            <h4><a :href="n.link" target="_blank">{{ n.title }}</a></h4>
          </div>
        </div>  
			</div>
		</div>

	</div>
</template>

<script>


export default {
  name: 'Relacionados'
}
</script>